module.exports = __webpack_public_path__ + "img/mastercard.9ecc5b28.png";